<mat-horizontal-stepper *ngIf="!loading" [selectedIndex]="stepIndex" class="wizard-background" linear="true" #stepper>
  <mat-step [completed]="admissionPracticeCompleted">
      <div>
        <div class="card-container  mat-elevation-z1">
          <ng-template matStepLabel>Paciente</ng-template>
          <app-admission-patient-component *ngIf="!loading" #admissionPatientComponent></app-admission-patient-component>
          <div class="clearfix">
            <div class="pull-right margin-right-medium">
              <button class="card-inline" type="button" (click)="cancel()" mat-button>CANCELAR</button>
            </div>
            <div class="card-footer">
              <button color="primary" type="submit" mat-flat-button matStepperNext>SIGUIENTE</button>
            </div>
          </div>
        </div>
      </div>
  </mat-step>
  <mat-step [completed]="admissionValorizationCompleted">
      <div>
        <div class="card-container">
          <ng-template matStepLabel>Valorización</ng-template>
          <app-admission-valorization-component *ngIf="!loading" #admissionValorizacionComponent></app-admission-valorization-component>
          <div class="clearfix">
            <div class="pull-right margin-right-medium">
              <button class="card-inline" type="button" (click)="cancel()" mat-button>CANCELAR</button>
            </div>
            <div class="card-footer">
              <button mat-button color="primary" type="button" matStepperPrevious>ANTERIOR</button>
              <button color="primary" type="submit" mat-flat-button matStepperNext>SIGUIENTE</button>
            </div>
          </div>
        </div>
      </div>
  </mat-step>
  <mat-step>
      <div>
        <div class="card-container">
          <ng-template matStepLabel>Orden</ng-template>
          <app-admission-medical-order-component *ngIf="!loading" #admissionMedicalOrderComponent></app-admission-medical-order-component>
          <div class="clearfix">
            <div class="pull-right margin-right-medium">
              <button class="card-inline" type="button" (click)="cancel()" mat-button>CANCELAR</button>
            </div>
            <div *ngIf="!loadingAction" class="card-footer">
              <button mat-button color="primary" type="button" matStepperPrevious>ANTERIOR</button>
              <button color="primary" type="button" (click)="finishAdmission()" mat-flat-button>SIGUIENTE</button>
            </div>
          </div>
        </div>
      </div>
  </mat-step>
</mat-horizontal-stepper>
<mat-spinner *ngIf="loading"></mat-spinner>
